import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { QuickbookNotificationService } from 'src/app/services/core/quickbook/notifications/quickbook-notification.service';
import { ToastService } from 'src/app/services/toast-service/toast.service';
import { QUICKBOOK_NOTIFICATION_ROUTES } from 'src/app/utils/notification-routes';

@UntilDestroy()
@Component({
  selector: 'app-quickbook-notifications',
  templateUrl: './quickbook-notifications.component.html'
})
export class QuickbookNotificationsComponent implements OnInit {
  search = '';
  user: any;
  timeZone: any;
  searchDate: any;
  notifications: any[] = [];
  totalResults = 0;
  currentPage = 1;
  limit = 50;

  constructor(
    private sharedDataService: SharedDataService,
    private quickbookNotificationService: QuickbookNotificationService,
    private toastService: ToastService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.timeZone = data.timeZone;
        this.searchDate = [moment.tz(this.timeZone || moment.tz.guess()).startOf('day').toISOString(), moment.tz(this.timeZone || moment.tz.guess()).endOf('day').toISOString()];
        this.getNotifications(this.currentPage = 1);
      }
    });
  }

  getNotifications(page: number) {
    this.quickbookNotificationService
      .getNotifications({ sortBy: 'createdAt:desc', ...(this.searchDate && { time: this.searchDate }), limit: this.limit, page })
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        this.notifications = data?.results || [];
        this.totalResults = data?.totalResults || 0;
      });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getNotifications(page);
  }

  onSearchDateChange(event: any) {
    // wait until both from and to are picked
    if (!event?.[0] || !event?.[1]) return;
    this.searchDate = [event[0].toISOString(), event[1].endOf('day').toISOString()];
    this.getNotifications(this.currentPage = 1);
  }

  onNotificationClick(notification: any) {
    this.markAsRead(notification);
    const route = QUICKBOOK_NOTIFICATION_ROUTES[notification?.type];
    if (route) {
      this.router.navigate([route]);
    }
  }

  onMarkAllAsRead() {
    this.quickbookNotificationService.markAllAsRead().pipe(untilDestroyed(this)).subscribe({
      next: () => {
        this.notifications.forEach((n: any) => n.isRead = true);
        this.quickbookNotificationService.setUnreadCount(0);
        this.toastService.show('All notifications marked as read.');
      },
      error: () => this.toastService.show('Failed to mark all as read.')
    });
  }

  hasUnreadNotifications(): boolean {
    return this.notifications.some((n: any) => !n.isRead);
  }

  markAsRead(notification: any) {
    if (!notification || notification.isRead) return;
    notification.isRead = true;
    this.quickbookNotificationService.decrementUnreadCount(1);
    // not tied to untilDestroyed: a click can navigate away and must not cancel the request
    this.quickbookNotificationService.markAsRead(notification.id || notification._id).subscribe({ error: () => { } });
  }

  getRelativeTime(date: any): string {
    return date ? moment(date).fromNow() : '';
  }
}
